import { LOCK } from 'Data/payment-plan.js'

export function getView(lock) {
  return lock === LOCK.PAYMENT_PLAN_LENGTH ? 'UnlockIcon' : 'LockIcon'
}
